import { Avatar, Box, Chip, Typography, useTheme } from '@mui/material'
import { first } from 'lodash'
import { Membership } from '~/common/generated/apollo-operations'
import { gray } from '~/common/styles/colors'
import { Tooltip } from './ui/atoms/tooltip/Tooltip'

interface UserChipProps {
  user: Pick<Membership, 'id' | 'firstName' | 'lastName' | 'email'>
}

/**
 * Renders a user chip with an avatar and first name
 */
export const UserChip = ({ user }: UserChipProps) => {
  const theme = useTheme()
  // Older users may have a blank name part, so skip it rather than show "undefined" or a stray space
  const fullName = `${user.firstName} ${user.lastName}`.trim()
  const initials = `${first(user.firstName) ?? ''}${first(user.lastName) ?? ''}`

  return (
    <Tooltip arrow placement="bottom-start" title={`${fullName} (${user.email})`}>
      <Chip
        icon={
          <Avatar
            key={user.id}
            sx={{
              width: 20,
              height: 20,
              fontSize: 10,
              backgroundColor: gray[4],
            }}
          >
            <Box color={`${theme.palette.text.secondary}`}>{initials}</Box>
          </Avatar>
        }
        label={
          <Typography sx={{ color: theme.palette.common.doss.gray[8] }} variant="body2">
            {fullName}
          </Typography>
        }
        sx={{
          margin: 0,
          paddingBlock: theme.spacing(0.5),
          paddingInline: theme.spacing(0),
          height: 'min-content',
          backgroundColor: 'transparent',
        }}
      />
    </Tooltip>
  )
}
